import logo from "../assets/tom-logo-icon-black.jpg"

import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function LogoLoader() {
  return (
    <Stack sx={{ height: '100vh', backgroundColor: 'rgba(0, 0, 0, 1.0)' }} justifyContent="center" alignItems="center">
      <img src={logo} alt="Takeoff Monkey Logo" style={{ height: '6em' }} />
      <Typography variant="h4" sx={{ mt: 1, mb: 5, userSelect: 'none' }}>Takeoff Monkey Widgets</Typography>
      <CircularProgress size="5em" color={'primary'} />
    </Stack>
  )
}